import * as StorageActions from 'actions/Storage';

export default function(state, action = {}) {

    switch (action.type) {
        case StorageActions.LOAD_STORAGE:
            return true;
    }

    return state;
}


// WEBPACK FOOTER //
// ./js/sport-betting/reducers/userSelectionStorableReducer.js